import { Sunrise, Sun, Moon } from "lucide-react";

export const RHYTHMS = [
    { key: "daily", label: "Daily" },
    { key: "weekly", label: "Weekly" },
    { key: "times_of_day", label: "Times of day" },
    { key: "none", label: "No reminders" },
];

// Legacy slot palette used by check-in edit form (morning/midday/evening chips) —
// kept for backward compat with older goals created before the rhythm rebuild.
export const ALL_SLOTS = [
    { key: "morning", label: "Morning", icon: Sunrise },
    { key: "midday", label: "Midday", icon: Sun },
    { key: "evening", label: "Evening", icon: Moon },
];

export const FREQUENCIES = [
    { key: "once", label: "Just once" },
    { key: "daily", label: "Daily" },
    { key: "weekly", label: "Weekly" },
    { key: "monthly", label: "Monthly" },
    { key: "none", label: "No schedule" },
];

export const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const TIME_PRESETS = [
    { key: "morning", label: "Morning", time: "08:00", icon: Sunrise },
    { key: "midday", label: "Midday", time: "12:00", icon: Sun },
    { key: "evening", label: "Evening", time: "20:00", icon: Moon },
];
